import React from 'react'

import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'
import { getBreakpointsEnable } from '../../../lib'
import AccountSettingsCard from '../containers/AccountSettingsCard'
import BoardSettingsCard from '../containers/BoardSettingsCard'
import SettingsMenuItems from '../containers/SettingsMenuItems'
import PaymentCard from '../containers/PaymentCard'
import DonationSettingsCard from '../containers/DonationSettingsCard'
import { useContext } from 'react'
import { Auth0Context } from '../../../Parts/Auth0'
import { useState } from 'react'
import { useEffect } from 'react'

const stylesSettings = theme => ({
  gridRoot: {
    maxWidth: 1200,
    width: '100%',
  },
  paper: {
    boxShadow: 'none',
  },
  settingBox: {
    backgroundColor: theme.palette.common.white,
    height: 500,
  }
})


function Settings(props) {
  const { init, classes, theme, user, settings, width } = props
  const auth0Context = useContext(Auth0Context)
  const [listenerID, setListenerID] = useState()
  const [isInitialized, setIsInitialized] = useState(false)

  useEffect(() => {
    if (user) {
      init(user)
      setIsInitialized(true)
    }
    setListenerID(auth0Context.onAuthStateChanged(changedUser => {
      if (changedUser && !isInitialized) {
        init(changedUser)
      }
    }))
    return () => {
      if (listenerID) {
        auth0Context.unregisterAuthStateChanged(listenerID)
      }
    }
  }, [])

  var { md, sm } = getBreakpointsEnable(theme, width)
  var styles = {
    gridRoot: {
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop:
        sm ? theme.spacing.unit * 13 : theme.spacing.unit * 11
    }
  }

  var defaultValues = {
    ...settings,
    avatarPhotoURL:
      settings && settings.avatarPhotoURL ? settings.avatarPhotoURL :
      user ? user.picture : undefined,
  }
  delete defaultValues.createDateTime

  return (
    <Grid container spacing={8} className={classes.gridRoot} style={styles.gridRoot}>
      {md && (
        <Grid item md={3}>
          <SettingsMenuItems/>
        </Grid>
      )}
      {user && settings && (
      <Grid item md={9} xs={12}>
        {
          props.match.params.menuItemName === undefined ? (md ? <AccountSettingsCard defaultValues={defaultValues}/> : <Grid item md={12}><SettingsMenuItems/></Grid>) :
          props.match.params.menuItemName === 'account' ? (<AccountSettingsCard defaultValues={defaultValues}/>) :
          props.match.params.menuItemName === 'board' ? (<BoardSettingsCard defaultValues={defaultValues}/>) :
          props.match.params.menuItemName === 'payment' ? (<PaymentCard/>) :
          props.match.params.menuItemName === 'donation' ? (<DonationSettingsCard/>) :
          (<div></div>)
        }
      </Grid>
      )}
    </Grid>
  )
}

export default withStyles(stylesSettings, { withTheme: true })(Settings)


// WEBPACK FOOTER //
// ./src/Pages/Settings/components/Settings.js